import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_07fce31c from 'nuxt_plugin_sentryserver_07fce31c' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_bb791cd8 from 'nuxt_plugin_sentryclient_bb791cd8' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_6503cb5e from 'nuxt_plugin_vuesocialsharingplugin_6503cb5e' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_vuescrollto_3eba17b1 from 'nuxt_plugin_vuescrollto_3eba17b1' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_portalvue_6a4247fb from 'nuxt_plugin_portalvue_6a4247fb' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_markdownit_65bbd3b4 from 'nuxt_plugin_markdownit_65bbd3b4' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_gtm_2e27b82e from 'nuxt_plugin_gtm_2e27b82e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_toast_70604807 from 'nuxt_plugin_toast_70604807' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_pluginrouting_d3b3a324 from 'nuxt_plugin_pluginrouting_d3b3a324' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7bf103c1 from 'nuxt_plugin_pluginmain_7bf103c1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_apollomodule_31cdef24 from 'nuxt_plugin_apollomodule_31cdef24' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_libmoduleplugin30156d36_204d6968 from 'nuxt_plugin_libmoduleplugin30156d36_204d6968' // Source: ./lib.module.plugin.30156d36.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_9c2ebb26 from 'nuxt_plugin_nuxtleaflet_9c2ebb26' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_intersectionobserver_47f04fea from 'nuxt_plugin_intersectionobserver_47f04fea' // Source: ./nuxt-polyfill/intersection-observer.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2237eb00 from 'nuxt_plugin_cookieuniversalnuxt_2237eb00' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_datefns_9e7f4118 from 'nuxt_plugin_datefns_9e7f4118' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_kameleoonIframeclient_fcbbe848 from 'nuxt_plugin_kameleoonIframeclient_fcbbe848' // Source: ../plugins/kameleoon-Iframe.client.js (mode: 'client')
import nuxt_plugin_gtm_2cfa83cb from 'nuxt_plugin_gtm_2cfa83cb' // Source: ../plugins/gtm.js (mode: 'all')
import nuxt_plugin_galinkerclient_6a8e6964 from 'nuxt_plugin_galinkerclient_6a8e6964' // Source: ../plugins/ga-linker.client.js (mode: 'client')
import nuxt_plugin_fontawesome_244e667e from 'nuxt_plugin_fontawesome_244e667e' // Source: ../plugins/font-awesome.js (mode: 'all')
import nuxt_plugin_vlazyimage_356cef6a from 'nuxt_plugin_vlazyimage_356cef6a' // Source: ../plugins/v-lazy-image.js (mode: 'all')
import nuxt_plugin_holidaygurucomponents_a70f062e from 'nuxt_plugin_holidaygurucomponents_a70f062e' // Source: ../plugins/holidayguru-components.js (mode: 'all')
import nuxt_plugin_veevalidate_21716614 from 'nuxt_plugin_veevalidate_21716614' // Source: ../plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_autosuggestclient_7ba605c2 from 'nuxt_plugin_autosuggestclient_7ba605c2' // Source: ../plugins/autosuggest.client.js (mode: 'client')
import nuxt_plugin_flickingclient_8d7633ee from 'nuxt_plugin_flickingclient_8d7633ee' // Source: ../plugins/flicking.client.js (mode: 'client')
import nuxt_plugin_observableclient_c5f19956 from 'nuxt_plugin_observableclient_c5f19956' // Source: ../plugins/observable.client.js (mode: 'client')
import nuxt_plugin_observevisibilityclient_29ee1675 from 'nuxt_plugin_observevisibilityclient_29ee1675' // Source: ../plugins/observe-visibility.client.js (mode: 'client')
import nuxt_plugin_shoppingmindsclient_19bbe7ba from 'nuxt_plugin_shoppingmindsclient_19bbe7ba' // Source: ../plugins/shoppingminds.client.js (mode: 'client')
import nuxt_plugin_paginationclient_79b2b4ec from 'nuxt_plugin_paginationclient_79b2b4ec' // Source: ../plugins/pagination.client.js (mode: 'client')
import nuxt_plugin_googleoauth2client_dbb27d8e from 'nuxt_plugin_googleoauth2client_dbb27d8e' // Source: ../plugins/google-oauth2.client.js (mode: 'client')
import nuxt_plugin_facebookclient_a46303d0 from 'nuxt_plugin_facebookclient_a46303d0' // Source: ../plugins/facebook.client.js (mode: 'client')
import nuxt_plugin_appleclient_28d17f78 from 'nuxt_plugin_appleclient_28d17f78' // Source: ../plugins/apple.client.js (mode: 'client')
import nuxt_plugin_tracifyclient_37a59f46 from 'nuxt_plugin_tracifyclient_37a59f46' // Source: ../plugins/tracify.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"link":[{"rel":"preload","href":"\u002F\u002Fdata-fd53e9bda6.urlaubsguru.de\u002Fiomm\u002Flatest\u002Fmanager\u002Fbase\u002Fes6\u002Fbundle.js","as":"script","type":"text\u002Fjavascript","crossorigin":true},{"rel":"preload","href":"\u002F\u002Fdata-fd53e9bda6.urlaubsguru.de\u002Fiomm\u002Flatest\u002Fbootstrap\u002Floader.js","as":"script","type":"text\u002Fjavascript","crossorigin":true},{"rel":"preload","href":"\u002Fassets\u002Ffont\u002Fasap-bold.woff2","as":"font","type":"font\u002Fwoff2"},{"rel":"preload","href":"\u002Fassets\u002Ffont\u002Fasap-medium.woff2","as":"font","type":"font\u002Fwoff2"},{"rel":"preload","href":"\u002Fassets\u002Ffont\u002Fasap-regular.woff2","as":"font","type":"font\u002Fwoff2"}],"script":[{"hid":"infonline","src":"https:\u002F\u002Fscript.ioam.de\u002Fiam.js?m=1","defer":true},{"hid":"infonline-bootstrap","src":"\u002F\u002Fdata-fd53e9bda6.urlaubsguru.de\u002Fiomm\u002Flatest\u002Fbootstrap\u002Floader.js"},{"hid":"facebook","src":"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Fsdk.js"},{"hid":"apple","src":"https:\u002F\u002Fappleid.cdn-apple.com\u002Fappleauth\u002Fstatic\u002Fjsapi\u002Fappleid\u002F1\u002Fen_US\u002Fappleid.auth.js"},{"hid":"kameleoon","src":"\u002F\u002F9tx2cmvs7s.kameleoon.eu\u002Fkameleoon.js"},{"hid":"tracify","src":"https:\u002F\u002Fscripting.tracify.ai\u002Fapi.v1.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"meta":[],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_07fce31c === 'function') {
    await nuxt_plugin_sentryserver_07fce31c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_bb791cd8 === 'function') {
    await nuxt_plugin_sentryclient_bb791cd8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_6503cb5e === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_6503cb5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_3eba17b1 === 'function') {
    await nuxt_plugin_vuescrollto_3eba17b1(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_6a4247fb === 'function') {
    await nuxt_plugin_portalvue_6a4247fb(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_65bbd3b4 === 'function') {
    await nuxt_plugin_markdownit_65bbd3b4(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2e27b82e === 'function') {
    await nuxt_plugin_gtm_2e27b82e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_70604807 === 'function') {
    await nuxt_plugin_toast_70604807(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_d3b3a324 === 'function') {
    await nuxt_plugin_pluginrouting_d3b3a324(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7bf103c1 === 'function') {
    await nuxt_plugin_pluginmain_7bf103c1(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_31cdef24 === 'function') {
    await nuxt_plugin_apollomodule_31cdef24(app.context, inject)
  }

  if (typeof nuxt_plugin_libmoduleplugin30156d36_204d6968 === 'function') {
    await nuxt_plugin_libmoduleplugin30156d36_204d6968(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_9c2ebb26 === 'function') {
    await nuxt_plugin_nuxtleaflet_9c2ebb26(app.context, inject)
  }

  if (typeof nuxt_plugin_intersectionobserver_47f04fea === 'function') {
    await nuxt_plugin_intersectionobserver_47f04fea(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2237eb00 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2237eb00(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_9e7f4118 === 'function') {
    await nuxt_plugin_datefns_9e7f4118(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_kameleoonIframeclient_fcbbe848 === 'function') {
    await nuxt_plugin_kameleoonIframeclient_fcbbe848(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2cfa83cb === 'function') {
    await nuxt_plugin_gtm_2cfa83cb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_galinkerclient_6a8e6964 === 'function') {
    await nuxt_plugin_galinkerclient_6a8e6964(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_244e667e === 'function') {
    await nuxt_plugin_fontawesome_244e667e(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyimage_356cef6a === 'function') {
    await nuxt_plugin_vlazyimage_356cef6a(app.context, inject)
  }

  if (typeof nuxt_plugin_holidaygurucomponents_a70f062e === 'function') {
    await nuxt_plugin_holidaygurucomponents_a70f062e(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_21716614 === 'function') {
    await nuxt_plugin_veevalidate_21716614(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_autosuggestclient_7ba605c2 === 'function') {
    await nuxt_plugin_autosuggestclient_7ba605c2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flickingclient_8d7633ee === 'function') {
    await nuxt_plugin_flickingclient_8d7633ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_observableclient_c5f19956 === 'function') {
    await nuxt_plugin_observableclient_c5f19956(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_observevisibilityclient_29ee1675 === 'function') {
    await nuxt_plugin_observevisibilityclient_29ee1675(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_shoppingmindsclient_19bbe7ba === 'function') {
    await nuxt_plugin_shoppingmindsclient_19bbe7ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paginationclient_79b2b4ec === 'function') {
    await nuxt_plugin_paginationclient_79b2b4ec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleoauth2client_dbb27d8e === 'function') {
    await nuxt_plugin_googleoauth2client_dbb27d8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebookclient_a46303d0 === 'function') {
    await nuxt_plugin_facebookclient_a46303d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appleclient_28d17f78 === 'function') {
    await nuxt_plugin_appleclient_28d17f78(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tracifyclient_37a59f46 === 'function') {
    await nuxt_plugin_tracifyclient_37a59f46(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
